import type { AnyResult } from './AnyResult';

export class ResultError extends Error {
  constructor(
    readonly result: AnyResult,
    reason?: string
  ) {
    let computedReason: string | undefined;
    if (result.success === true) {
      computedReason = reason ?? 'SUCCESS_RESULT_AS_ERROR_RESULT';
    } else {
      computedReason = reason ?? result.reason;
    }

    super(`ERROR_RESULT with reason: ${computedReason}`);
  }
}

export function ThrowResultError(result: AnyResult, reason?: string): never {
  throw new ResultError(result, reason);
}
